module.exports = __webpack_public_path__ + "img/alabangvx-logo.c3677372.png";